<template>
  <div>
    <b-row>
      <b-col md="6">
        <div class="mb-2" v-if="creative.type === 'image'">
          <img :src="creative.image.mediaUrl" :alt="creative.image.mediaUrl" />
        </div>
        <div>
          <div class="mb-2">
            <span class="text-light">ID: </span>
            <span>{{ creative.id }}</span>
          </div>
          <div class="mb-2" v-if="creative.type === 'video'">
            <span class="text-light">Link to file: </span>
            <a :href="creative.video.mediaUrl" target="_blank">{{
              creative.video.mediaUrl
            }}</a>
          </div>
          <div v-if="dimensions" class="mb-2">
            <span class="text-light">Dimension: </span>
            <span>{{ dimensions }}</span>
          </div>
          <div class="mb-2">
            <span class="text-light">Campaigns: </span>
            <span>0</span>
          </div>
        </div>
      </b-col>
      <b-col md="6">
        <div class="ad-tags-list">
          <b-form-group label="Ad tags:" class="mb-0">
            <b-form-checkbox-group
              id="checkbox-group-2"
              v-model="selectedAdTags"
            >
              <b-form-checkbox
                v-for="tag in adTags"
                :key="tag.id"
                :value="tag.id"
                class="d-block"
              >
                {{ tag.text }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </div>
        <button
          class="btn btn-link-alt mt-2"
          type="button"
          @click="upadteCreativeTags"
        >
          <svg-icon icon="reset" class="text-success icon-sm" />
          <span>Update creative Ad tags</span>
        </button>
        <hr />
        <div class="mb-2">
          <span class="text-light">Status: </span>
          <span :class="`text-${statusClass(creative.status)}`">{{
            creative.status
          }}</span>
        </div>
        <div v-if="!toReject">
          <button
            v-if="
              creative.status === 'pending' || creative.status === 'rejected'
            "
            class="btn btn-sm btn-success"
            @click="changeStatus('approve')"
          >
            Approve
          </button>
          <button
            v-if="
              creative.status === 'pending' || creative.status === 'approved'
            "
            class="btn btn-sm btn-danger"
            @click="changeStatus('reject')"
          >
            Reject
          </button>
        </div>
        <div v-if="toReject">
          <b-form-group label="Reject reason" label-for="reject-reasons">
            <multi-select
              id="reject-reasons"
              :search="rejectReasons.length > 9"
              :select-options="rejectReasons"
              v-model="rejectionReason.reason"
              btn-label="Choose Creative format"
              size="lg"
            />
          </b-form-group>
          <b-form-textarea
            id="description"
            v-model="rejectionReason.description"
            placeholder="Rejection reason description"
            :disabled="isDisabledDescription"
            size="lg"
          />
          <div class="mt-2 clearfix">
            <button class="btn btn-link-alt" @click="cancel">
              cancel
            </button>
            <button
              class="btn btn-sm btn-danger float-right"
              @click="rejectCreative()"
              :disabled="isDisabledRejection"
            >
              Reject
            </button>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { statusClassesMixin } from '@/utils/mixins.js';
import cloneDeep from 'clone';

export default {
  mixins: [statusClassesMixin],

  props: {
    creative: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      adTags: [
        {
          id: 0,
          text: 'Auto-sound'
        },
        {
          id: 1,
          text: 'Blinking elements'
        },
        {
          id: 2,
          text: 'Auto-play'
        }
      ],
      selectedAdTags: [],
      rejectReasons: [
        {
          id: 0,
          name: 'Custom reason'
        },
        {
          id: 1,
          name: 'Unaccaptable content'
        },
        {
          id: 2,
          name: 'Not suitable for work'
        },
        {
          id: 3,
          name: 'Low quality'
        }
      ],
      toReject: false,
      rejectionReason: {
        description: null,
        reason: [
          {
            id: 0,
            name: 'Custom reason'
          }
        ]
      }
    };
  },

  computed: {
    dimensions() {
      if (!this.creative.id || !this.creative.image) return false;
      return `${this.creative.image.width}x${this.creative.image.height}`;
    },
    isDisabledDescription() {
      return this.rejectionReason.reason[0].id !== 0;
    },
    isDisabledRejection() {
      return (
        this.rejectionReason.description === null ||
        this.rejectionReason.description.length < 5
      );
    }
  },

  watch: {
    'rejectionReason.reason': {
      handler() {
        this.rejectionReason.description =
          this.rejectionReason.reason[0].id === 0
            ? null
            : this.rejectionReason.reason[0].name;
      }
    }
  },

  methods: {
    changeStatus(status) {
      if (status === 'approve') {
        this.approveCreative();
      } else {
        this.toReject = true;
      }
    },
    cancel() {
      this.toReject = false;
      this.rejectionReason.reason = [this.rejectReasons[0]];
    },
    approveCreative() {
      this.$api.adnet.put(`/dsp/creatives/approve/${this.creative.id}`).then(
        () => {
          this.$notify('alert', {
            text: `Creative - ID ${this.creative.id} approved.`,
            variant: 'success',
            time: 5000
          });
          this.$emit('update-list');
        },
        e => {
          e.response.data.detail &&
            this.$notify('alert', {
              text: e.response.data.detail,
              variant: 'danger',
              time: 0
            });
        }
      );
    },
    rejectCreative() {
      const reason = {
        id: this.creative.id,
        reason: this.rejectionReason.reason[0].id,
        description: this.rejectionReason.description
      };
      this.$api.adnet
        .put(`/dsp/creatives/reject/${this.creative.id}`, reason)
        .then(
          () => {
            this.$notify('alert', {
              text: `Creative - ID ${this.creative.id} rejected.`,
              variant: 'danger',
              time: 5000
            });
            this.$emit('update-list');
          },
          e => {
            e.response.data.detail &&
              this.$notify('alert', {
                text: e.response.data.detail,
                variant: 'danger',
                time: 0
              });
          }
        );
    },
    upadteCreativeTags() {
      const creative = {
        id: this.creative.id,
        adTags: this.selectedAdTags
      };
      this.$api.adnet.put(`/dsp/creatives/${this.creative.id}`, creative).then(
        () => {
          this.$notify('alert', {
            text: `Creative tags - ID ${this.creative.id} updated.`,
            variant: 'success',
            time: 5000
          });
        },
        e => {
          e.response.data.detail &&
            this.$notify('alert', {
              text: e.response.data.detail,
              variant: 'danger',
              time: 0
            });
        }
      );
    },
    setupAdTags() {
      if (this.creative.adTags.length === 0) return;
      this.selectedAdTags = cloneDeep(this.creative.adTags);
    }
  },

  created() {
    this.setupAdTags();
  }
};
</script>

<style lang="scss">
.ad-tags-list {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
button {
  &:disabled {
    pointer-events: none;
    cursor: default;
  }
}
</style>
